export default "__VITE_ASSET__Bp4tfz1l__"